// removed by extract-text-webpack-plugin
module.exports = {"main-content":"footer-2mD","button":"footer-2fQ","select-product-1":"footer-258","select-product-2":"footer-2d9","last-resource":"footer-gla"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/Footer/MainContent/main-content.module.scss
// module id = 299
// module chunks = 0